import React, { useEffect } from "react";
import CustomDropdown from "../../Atoms/DropDowns/CustomDropdown";
import { useAgent } from "../../../contexts/AgentsContext";
import { CircularProgress } from "@mui/material";

const AgentVersionDropdown = () => {
  const {
    agentVersions,
    selectAgentVersion,
    currentAgentVersion,
    isLoadingVersions,
    selectedAgent,
    versionsFetchError,
    setIsLatestVersion
  } = useAgent();

  useEffect(() => {
    if (agentVersions && agentVersions.length > 0) {
      const highestVersion = agentVersions
        .map((v) => v?.version)
        .sort((a, b) => (a > b ? -1 : 1))[0];

      selectAgentVersion(highestVersion);
    }
  }, [selectedAgent, agentVersions]);

  useEffect(() => {
    if (agentVersions && agentVersions.length > 0 && currentAgentVersion) {
      const highestVersion = agentVersions
        .map((v) => v?.version)
        .sort((a, b) => (a > b ? -1 : 1))[0];

      setIsLatestVersion(currentAgentVersion === highestVersion);
    }
  }, [currentAgentVersion, agentVersions]);

  const versions = agentVersions?.map((version) => ({
    value: version?.version,
    label: `Release ${version?.version}`,
  }));

  return (
    <section className="sol-drawer-container">
      <span className="sol-drawer-title">Agent Details</span>
      <div className="wd-14 d-flex" style={{ width: "30%" }}>
        {isLoadingVersions && (
          <div className="d-flex align-items-center justify-content-center me-2">
            <CircularProgress
              style={{ width: "15px", height: "15px", opacity: 0.8 }}
            />
          </div>
        )}
        <CustomDropdown
          selectValues={versions || []}
          handleOnChange={(selectedOption) => {
            selectAgentVersion(selectedOption);
          }}
          dropdownLabel={`Release`}
          clsNames={"mas-cust-dd-primary mas-cust-dd-2"}
          disabled={isLoadingVersions || versionsFetchError}
          value={currentAgentVersion}
        />
      </div>
    </section>
  );
};

export default AgentVersionDropdown;
